import styled, { css, keyframes } from 'styled-components'

const bounce = keyframes`
  0% {
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

const animation = () =>
  css`
    ${bounce} 2s infinite;
  `

const AnimatedComponent = styled.div`
  animation: ${animation};
`

export default AnimatedComponent
